module.exports = __webpack_public_path__ + "img/snow_fall_00011.a6328e13.png";